import { MasterDocument } from '@util/firestore/master';
import { ProductDocument } from '@util/types/firestore/products';
import { getProductUrl } from '@util/urlHelpers';
import { salePriceValidUntil } from '@c/StructuredData';

interface ProductSchemaProps {
  product: ProductDocument;
  master?: MasterDocument | null
  pricing?: { unitCents: number; applied: { endsAt: number } | null };
}

const ProductSchema: React.FC<ProductSchemaProps> = ({ product, master, pricing }) => {
  const availability = product.stock > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';
  const condition = product.condition === 'New' ? 'https://schema.org/NewCondition' : 'https://schema.org/UsedCondition';
  const priceValidUntil = pricing?.applied
    ? salePriceValidUntil(pricing.applied.endsAt)
    : new Date().toISOString().split('T')[0];

  return (
    <div itemScope itemType="https://schema.org/Product">
      <meta itemProp="name" content={product.title} />
      <meta itemProp="description" content={product.description} />
      <meta itemProp="sku" content={product.sku} />
      <meta itemProp="brand" content={product.brand} />
      <meta itemProp="image" content={product.thumbnail} />
      <div itemProp="offers" itemScope itemType="https://schema.org/Offer">
        <meta itemProp="price" content={(pricing?.applied ? pricing.unitCents / 100 : product.price).toString()} />
        <meta itemProp="priceCurrency" content="USD" />
        <meta itemProp="availability" content={availability} />
        <meta itemProp="priceValidUntil" content={priceValidUntil} />
        <meta itemProp="url" content={getProductUrl(product.slug)} />
        <meta itemProp="category" content={getProductUrl(product.slug)} />
      </div>
      <div itemProp="category" itemScope itemType="https://schema.org/Thing">
        {product.categories.map((category: string) => (
          <meta key={category} itemProp="name" content={category} />
        ))}
        {master && (
          <meta itemProp="name" content={master.title} />
        )}
      </div>
      <meta itemProp="itemCondition" content={condition} />
    </div>
  );
};

export default ProductSchema;
